// extracted by mini-css-extract-plugin
export default {"addToCartControl":"P1-z","giftCard":"Q1-z","btnContainer":"R1-z","cartButton":"S1-z","disabled":"T1-z"};